<rask-page
  pageTitle="{{ 'KUND_LIST_SOK' | translate }}" noPadding>
  <ng-container headerContent>
    @if (kunderSearchParams) {
      <form [formGroup]="form" (ngSubmit)="search()">
        <div class="row pb-2">
          <rask-search
            aid="inputNamn"
            class="col-3"
            label="{{'DEFAULT_BUTTON_LABEL_SOK' | translate}}"
            bindLabel="namn"
            bindValue="namn"
            formControlName="sokTypeAhead"
            typeToSearchText="{{'KUND_SOK_PLACEHOLDER' | translate}}"
            loadingText="Laddar..."
            notFoundText="Ingen träff"
            [minTermLength]="3"
            [typeaheadFn]="searchKundTypeAhead"
            [selected]="form.value.sokTypeAhead">
          </rask-search>
          <rask-radiobutton-group
            aid="radioAktiv"
            class="col-2"
            label="{{'KUND_LIST_AKTIV' | translate}}"
            formControlName="aktiv"
            [buttons]="aktivButtons">
          </rask-radiobutton-group>
        </div>
        <rask-toggle-panel  label="{{ 'DEFAULT_VISA_AVANCERATFILTER' | translate }}" [defaultExpanded]="false">
          <div class="row">
            <rask-input aid="inputHuvudkod" class="col-3" label="{{ 'KUND_DETAIL_HUVUDKOD' | translate }}" formControlName="huvudkod" [rule]=""></rask-input>
            <rask-input aid="inputInternnummer" class="col-3" label="{{ 'KUND_DETAIL_INTERNNUMMER' | translate }}" formControlName="internnummer" [rule]=""></rask-input>
            <rask-input aid="inputBesokPostortadress" class="col-3" label="{{ 'KUND_LIST_BESOKPOSTORTADRESS' | translate }}" formControlName="besokPostortadress" [rule]=""></rask-input>
            <rask-input aid="inputLimeId" class="col-3" label="{{ 'KUND_LIST_LIMEID' | translate }}" formControlName="limeId" [rule]=""></rask-input>
          </div>
          <div class="row">
            <rask-input aid="inputOrgNummer" class="col-3" label="{{ 'KUND_LIST_ORGNUMMER' | translate }}" formControlName="orgNummer" [rule]=""></rask-input>
            <rask-input aid="inputBeskrivning" class="col-3" label="{{ 'KUND_LIST_BESKRIVNING' | translate }}" formControlName="beskrivning" [rule]=""></rask-input>
            <rask-radiobutton-group
              aid="radioBefraktare"
              class="col-3"
              label="Befraktare"
              formControlName="befraktare"
              [buttons]="befraktareButtons">
            </rask-radiobutton-group>
          </div>
        </rask-toggle-panel>
        <div class="row">
          <div class="col">
            <rask-submit-button aid="buttonSok" class="ps-0" color="secondary">{{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}</rask-submit-button>
            <rask-button aid="buttonRensa" color="secondary" negative (click)="reset()">{{ 'DEFAULT_BUTTON_LABEL_RENSA' | translate }}</rask-button>
          </div>
        </div>
      </form>
    }
  </ng-container>
  <rask-kund-list [kunder]="kunder"></rask-kund-list>
</rask-page>
